import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import { Translation } from "src/app/Models/translation.interface";
import { AngularFirestore } from "@angular/fire/firestore";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";
import { produce } from "immer";
import { LanguageDraft } from "../../Models/language-models.interface";
import { Lesson } from "../../Models/lessons.interface";
@Component({
  selector: "app-config-editor",
  templateUrl: "./config-editor.component.html",
  styleUrls: ["./config-editor.component.css"],
})
export class ConfigEditorComponent implements OnInit {
  @Input() translationConfig: Translation;
  @Input() lang: string;
  @Input() draftConfig: LanguageDraft;
  @Input() draftLessons: Record<string, Lesson>;
  preview = false;
  constructor(
    private ls: LanguageSwitchService,
    private afs: AngularFirestore
  ) {}

  config: Map<unknown, unknown>;
  lessonsCards: Translation["topics"]["lessonsCards"] = [];

  toggle: "config" | "lessons" = "config";

  setToggle = (toggle: "config" | "lessons") => {
    this.toggle = toggle;
  };

  ngOnInit() {
    this.config = this.translationConfig as unknown as Map<unknown, unknown>;
    this.lessonsCards = this.translationConfig?.topics?.lessonsCards ?? [];
    this.flattenAndSendConfig(this.config as unknown as Translation);
  }

  flattenAndSendConfig = (nextConfig: Translation) => {
    this.ls.overrideLanguageConfig(nextConfig);
  };

  ngAfterViewInit() {
    console.log(this.config);
  }
  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes.translationConfig) {
  //     this.config = {
  //       ...changes.translationConfig.currentValue,
  //     } as unknown as Translation;
  //     this.lessonsCards =
  //       changes.translationConfig.currentValue?.topics?.lessonsCards ?? [];
  //   }
  // }

  updateValue = async (item, subItem) => {
    const nconfig = produce(this.config, (draft) => {
      draft[item.key][subItem.key] = subItem.value;
    });

    // update the server
    await this.afs
      .collection("Languages")
      .doc(this.lang)
      .collection("Drafts")
      .doc(String(this.draftConfig.version))
      .collection("Config")
      .doc(item.key)
      .update({ [subItem.key]: subItem.value });

    this.flattenAndSendConfig(nconfig as unknown as Translation);
  };

  updateLessonCard = (item, subItem, subSubItem) => {
    // You might be wondering why we dont produce the draft here
    // and well, i'm not sure why, using a draft with produce
    // seems to still mess up the state of the config object
    // in such a way that the array becomes read only.
    // So we are just going to manually update the array
    // and after saving to the server, we will manually rebuild
    // the config object and send it to the language switch service
    const array = this.config[item.key][subItem.key].map((lesson) => {
      if (lesson.id === subSubItem.id) {
        return subSubItem;
      }
      return lesson;
    });

    // update the server
    this.afs
      .collection("Languages")
      .doc(this.lang)
      .collection("Drafts")
      .doc(String(this.draftConfig.version))
      .collection("Config")
      .doc(item.key)
      .update({ [subItem.key]: array });

    this.flattenAndSendConfig({
      ...this.config,
      [item.key]: {
        ...this.config[item.key],
        [subItem.key]: array,
      },
    } as unknown as Translation);
  };
}
